import React, { useState, useEffect, useRef } from 'react'
import { Row, Form, Button, Col, Accordion } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import { useCreateCourseMutation, useGetCourseQuery, useCreateLessonMutation, useAddSectionMutation } from '../../slices/teachers/courseApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import VideoJS from '../../components/VideoJs';


const TeacherWatchCourse = () => {

    const playerRef = useRef(null);

    const navigate = useNavigate();
    const { id } = useParams();
    const { studentInfo } = useSelector((state) => state.authStudent);

    const [name, setName] = useState('');
    const [lessonsBySection, setLessonsBySection] = useState([]);   
    const [mediaId, setMediaId] = useState();
    const [lessonTitle, setLessonTitle] = useState();
    const [subjectId, setSubjectId] = useState();
    const [activeLesson, setActiveLesson] = useState(null);
    const [loading, setLoading] = useState(false);

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const { data, error, isLoading, refetch } = useGetCourseQuery(id);

    const goToQuestion = () => {
         window.open(`${window.location.origin}/studentaskdetails/${subjectId}`, '_blank')
      }

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])
    
    useEffect(() => {
        setName(data?.name);
        setSubjectId(data?.subject)
        const groupedLessons = data?.lessons.reduce((acc, lesson) => {
            if (!acc[lesson.sectionNumber]) {
                acc[lesson.sectionNumber] = [];
            }
            acc[lesson.sectionNumber].push(lesson);
            return acc;
        }, []);
        groupedLessons?.forEach(section => {
            section.sort((a, b) => a.lessonNumber - b.lessonNumber);
        });
        setLessonsBySection(groupedLessons);
    }, [data]);

    useEffect(() => {
        if (lessonsBySection?.length > 0) {
            setMediaId(lessonsBySection[1][0].mediaId)
            setLessonTitle(lessonsBySection[1][0].title)
            setActiveLesson(lessonsBySection[1][0])
        }       
      }, [lessonsBySection]); 

    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
          src: `https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/lessons/${mediaId}`,
          type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        player.on('waiting', () => {});
        player.on('dispose', () => {});
    };

   const videoHandler = (lesson) => {
        setLoading(true);
        setMediaId(lesson.mediaId)
        setActiveLesson(lesson); 
        setLessonTitle(lesson.title)
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
        <TeacherHeader /><br />
        <div className="">
                    {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (
                    <>
                        <div className="row">
                            <div  className="col-sm-7  ">
                                <h3 className="centerTitle tittleColor4 courseTitle2">
                                    <span className='courseTitle' style={{textTransform: 'capitalize'}}>
                                    {name}
                                    </span>
                                </h3>
                            </div>
                        </div>
                        <div className="row ">
                            <div  className=" col-xl-7 courseAccord">
                                {!loading ? (
                                <>                                   
                                    <VideoJS 
                                      options={videoJsOptions} 
                                      onReady={handlePlayerReady} 
                                      cssRule="card-img-top lessonVid"
                                    />
                                    <br /><br />   
                                    <div className='mycard'>
                                    <LinkContainer to={`/teachernewlessons/${id}`} className='btn btn-default '>
                                    <Button   type='submit' variant="info rounded-pill bg-gradient-info btn-lg lessonAsk3 "
                                     > 
                                        Add Lessons 
                                    </Button>
                                    </LinkContainer>
                                    </div>                                                                                  
                                </>                    
                                ) : (     
                                    <>             
                                        <br /><br /><br /><br />
                                        <Loader className="load2" />
                                    </>
                                )}   
                            </div>                         
                            <div className="offset-xl-2  col-xl-3 ">       
                                <Accordion defaultActiveKey="1" className='accord' >
                                    {lessonsBySection?.map((sec, sectionIndexx) => (
                                        <div key={sectionIndexx}>
                                            {sec.map((lesson, lessonIndex) => (
                                                <>
                                                <Accordion.Item eventKey={`${sectionIndexx}`}>
                                                    {lessonIndex === 0 && (                                                    
                                                        <Accordion.Header className=''> <p className='courseSection'>
                                                            Section {sectionIndexx}: {lesson.section}</p>
                                                        </Accordion.Header>                                                
                                                    )}
                                                    <Accordion.Body className={lesson === activeLesson ? "activee" : ""} >
                                                        <p onClick={() => videoHandler(lesson)} style={{ cursor: "pointer" }}>
                                                            <i className="ni ni-button-play  LessonPlay"></i> 
                                                            <span className='lessonT'>
                                                            {lesson.title} 
                                                            </span>
                                                        </p>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                </>
                                            ))}
                                        </div>
                                    ))}
                                </Accordion>                                           
                            </div>                   
                        </div>
                    </>
                    )} 
                </div>
        </div>
    </div>
    )
}

export default TeacherWatchCourse
